import { Grid, Paper, Typography, Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Input, InputDate, Select } from "../../controls";
import { Form } from "../../layout";
import { DropLi, Model, UseForm } from "../../hooks";
import { useNavigate, useParams } from "react-router-dom";
import { Alert } from "../../layout";
import { connect } from "react-redux";
import * as actions from "../../api/actions/pos";
import { controller, endpoints } from "../../api/actions/api";
import {
  ToFormData,
  RmvEmptyProp,
  RmvNullProp,
  IsEmptyObj,
  MaxLength,
} from "../../hooks/Method";
import { useEffect } from "react";
import { useState } from "react";
import storeCountries from "../../config/storeCountries.json";

const AddEditStore = (props) => {
  const { t } = useTranslation();
  const { _post, _put, _get, _data, _getById, _clearState } = props;
  const { StoreMdl } = Model();
  const { id } = useParams();
  const navigate = useNavigate();
  const [alert, setAlert] = useState({
      isOpen: false,
      type: "",
      title: "",
      subTitle: "",
    });
  const [loading, setLoading] = useState(false);
  const { Gender, StoreCountries } = DropLi();
  const StoreCurrencies = [
    ...new Map(
      storeCountries.map((country) => [
        country.currency,
        {
          id: country.currency,
          name: country.currency,
        },
      ])
    ).values(),
  ];
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    handleInpDate,
    resetFormControls,
  } = UseForm(StoreMdl);

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;

    const selectedCountry = storeCountries.find(
      (country) => country.code === countryCode
    );

    if (!selectedCountry) return;

    setValues((prev) => ({
      ...prev,
      countryCode: selectedCountry.code,
      currencyCode: selectedCountry.currency,
      currencyLocale: selectedCountry.locale,
    }));
  };

  useEffect(() => {
    if (id !== "undefined") {
      _getById(
        endpoints.Store + controller.GetById,
        id,
        actions.ActionType.Data
      );
    }
    return () => {
      _clearState({}, actions.ActionType.ClearData);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (id !== "undefined" && !IsEmptyObj(_data))
      setValues({ ...values, ...RmvNullProp(_data) });
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_data]);

    const validateForm = () => {
      let temp = {};

      temp.storeName =
        values.storeName !== "" ? "" : t("storeNameRequired");

      temp.firstName =
        values.firstName !== "" ? "" : t("firstNameRequired");

      temp.lastName =
        values.lastName !== "" ? "" : t("lastNameRequired");

      temp.tax =
        values.tax !== "" ? "" : t("taxPercentageRequired");

      setErrors({ ...temp });

      return Object.values(temp).every((x) => x === "");
    };
 
  const handleSubmit = (e) => {
  e.preventDefault();

  const onComplete = (res, err) => {
    setLoading(false);

    if (err) {
      setAlert({
        isOpen: true,
        type: "error",
        title: t("error"),
        subTitle: err.msg || t("unableToSaveStore"),
      });
      return;
    }

    if (res?.status === 201 || res?.status === 200) {
      _get(
        endpoints.Store,
        actions.ActionType.Store,
        () => navigate("/store-settings")
      );
      return;
    }

    setAlert({
      isOpen: true,
      type: "warning",
      title: t("storeLimitReached"),
      subTitle: res?.msg || t("unableToSaveStore"),
    });
  };

  if (validateForm()) {
    setLoading(true);

    if (id === "undefined") {
      _post(
        endpoints.Store,
        ToFormData(RmvEmptyProp(values)),
        actions.ActionType.Data,
        onComplete
      );
    } else if (id !== 0) {
      _put(
        endpoints.Store,
        ToFormData(RmvEmptyProp(values)),
        actions.ActionType.Data,
        onComplete
      );
    }
  }
};

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Box className="tx-center p-20">
          <Typography variant="h5" className="fs-26 gray-color fw-5 tx-upp">
            {id === "undefined" ? t("addStore") : t("updateStore")}
          </Typography>
          <div className="bs-bottom mx-w-60 mt-5 m-auto" />
        </Box>
        {/* Store Details */}
        <div className="pt-20" />
        <Paper className="mt-30 shadow-xs br-8">
          <Grid container spacing={3} className="p-20 pt-0">
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                className="fs-20 fw-5 gray-color pl-10"
                sx={{ borderLeft: "5px double var(--primary-color)" }}
              >
                {t("storeDetails")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("storeName")}
                name="storeName"
                value={values.storeName}
                error={errors.storeName}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("phone")}
                name="phone"
                value={values.phone}
                error={errors.phone}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("taxPercentage")}
                name="tax"
                value={values.tax}
                error={errors.tax}
                type="number"
                onChange={handleInpChg}
                onInput={(e) => (e.target.value = MaxLength(e.target.value, 3))}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("address")}
                name="address"
                value={values.address}
                error={errors.address}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("city")}
                name="city"
                value={values.city}
                error={errors.city}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("state")}
                name="state"
                value={values.state}
                error={errors.state}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("zip")}
                name="zip"
                value={values.zip}
                error={errors.zip}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Store Currency Settings */}
        <div className="pt-20" />
        <Paper className="mt-30 shadow-xs br-8">
          <Grid container spacing={3} className="p-20 pt-0">
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                className="fs-20 fw-5 gray-color pl-10"
                sx={{
                  borderLeft: "5px double var(--primary-color)"
                }}
              >
                {t("storeCurrencySettings")}
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Select
                label={t("country")}
                name="countryCode"
                value={values.countryCode || "US"}
                onChange={handleCountryChange}
                options={StoreCountries}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Input
                label={t("currency")}
                name="currencyCode"
                value={values.currencyCode || "USD"}
                onChange={handleInpChg}
                options={StoreCurrencies}
                fullWidth
              />
            </Grid>

            {/* <Grid item xs={12} md={4}>
              <Input
                label={t("currencyLocale")}
                name="currencyLocale"
                value={values.currencyLocale || "en-US"}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid> */}

            <Grid item xs={12}>
              <Typography variant="body2">
                {t("currencyPreview")}:{" "}
                {new Intl.NumberFormat(
                  values.currencyLocale || "en-US",
                  {
                    style: "currency",
                    currency: values.currencyCode || "USD",
                  }
                ).format(1250)}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Manager Details */}
        <div className="pt-20" />
        <Paper className="mt-30 shadow-xs br-8">
          <Grid container spacing={3} className="p-20 pt-0">
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                className="fs-20 fw-5 gray-color pl-10"
                sx={{ borderLeft: "5px double var(--primary-color)" }}
              >
                {t("managerDetails")}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("firstName")}
                name="firstName"
                value={values.firstName}
                error={errors.firstName}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("lastName")}
                name="lastName"
                value={values.lastName}
                error={errors.lastName}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputDate
                label={t("dateOfBirth")}
                name="dob"
                value={values.dob}
                error={errors.dob}
                onChange={(date) => handleInpDate("dob", date)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Select
                label={t("gender")}
                name="gender"
                fullWidth
                value={values.gender}
                error={errors.gender}
                onChange={handleInpChg}
                options={Gender}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("phone")}
                name="mngPhone"
                value={values.mngPhone}
                error={errors.mngPhone}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("ssn")}
                name="ssn"
                value={values.ssn}
                error={errors.ssn}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("address")}
                name="mngAddress"
                value={values.mngAddress}
                error={errors.mngAddress}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("city")}
                name="mngCity"
                value={values.mngCity}
                error={errors.mngCity}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("state")}
                name="mngState"
                value={values.mngState}
                error={errors.mngState}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("zip")}
                name="mngZip"
                value={values.mngZip}
                error={errors.mngZip}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} className="tx-right">
              <Button
                loading={loading}
                type="submit"
                className="mt-10"
                sx={{ width: { md: "150px", xs: "100%" } }}
                size="large"
              >
                {id === "undefined" ? t("submit") : t("saveChanges")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

const mapStateToProps = (state) => ({
  _data: state.pos.data,
});

const mapActionToProps = {
  _get: actions.get,
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
  _clearState: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditStore);
